export default "__VITE_ASSET__i559rcBO__"